import React, { createContext, useState } from 'react'
import { IOrderData, TMeltingLot, TLineDetails, TInboundFields, TCharge, TTransitionHistory } from '../Models/Inbound';
import { TTransferPvcToPlant } from '../Models/TrasferOrderPvcToPlant';
import { TCartItem, TLineItem, TSku } from '../Models/PhysicalOrder';
import { TDelivery } from '../Models/Delivery';
import { TBilling, TPayment } from '../Models/Billing';
import { TStepsKeys } from '../Models/common';
import { TOrder, TTransactionBasic, TTransactionDocuments, TTransactionImage, TTransactionInvoice, TTransactionSummary, TUSerAuthFile } from '../Models/Transactions';
import { IPvcCenterSummary } from '../Models/PVC';
import { TInventory } from '../Models/Inventory';

export type TTransactionContext = {
  inboundDetails: TInboundFields, setInboundDetails: React.Dispatch<React.SetStateAction<TInboundFields>>
  meltingLot: TMeltingLot[], setMeltingLot: React.Dispatch<React.SetStateAction<TMeltingLot[]>>
  lineDetails: TLineDetails[], setLineDetails: React.Dispatch<React.SetStateAction<TLineDetails[]>>
  lineItems: TLineItem[], setLineItems: React.Dispatch<React.SetStateAction<TLineItem[]>>
  transferPvcToPlant: TTransferPvcToPlant, setTransferPvcToPlant: React.Dispatch<React.SetStateAction<TTransferPvcToPlant>>
  physicalOrder: TOrder, setPhysicalOrder: React.Dispatch<React.SetStateAction<TOrder>>
  deliveryData: TDelivery[], setDeliveryData: React.Dispatch<React.SetStateAction<TDelivery[]>>
  billingData: TBilling, setBillingData: React.Dispatch<React.SetStateAction<TBilling>>,
  capturedSteps: TStepsKeys[], setCapturedSteps: React.Dispatch<React.SetStateAction<TStepsKeys[]>>,
  transactionInfo: TTransactionBasic, setTransactionInfo: React.Dispatch<React.SetStateAction<TTransactionBasic>>,
  transactions: TTransactionSummary[], setTransactions: React.Dispatch<React.SetStateAction<TTransactionSummary[]>>,
  products: TSku[], setProducts: React.Dispatch<React.SetStateAction<TSku[]>>,
  cart: TCartItem[], setCart: React.Dispatch<React.SetStateAction<TCartItem[]>>,
  inboundOrder: TOrder, setInboundOrder: React.Dispatch<React.SetStateAction<TOrder>>
  charges: TCharge[], setCharges: React.Dispatch<React.SetStateAction<TCharge[]>>,
  payments: TPayment[], setPayments: React.Dispatch<React.SetStateAction<TPayment[]>>,
  transitionHistory:TTransitionHistory[], setTransitionHistory: React.Dispatch<React.SetStateAction<TTransitionHistory[]>>,
  pvcCenterDetails:IPvcCenterSummary, setPvcCenterDetails: React.Dispatch<React.SetStateAction<IPvcCenterSummary>>,
  jobworkInventory:TInventory, setJobworkInventory: React.Dispatch<React.SetStateAction<TInventory>>,
  pvcCenters:IPvcCenterSummary[], setPvcCenters: React.Dispatch<React.SetStateAction<IPvcCenterSummary[]>>,
  isInventoryExist: boolean, setIsInventory: React.Dispatch<React.SetStateAction<boolean>>,
  isEmployeeVerified: boolean,setIsEmployeeVerified: React.Dispatch<React.SetStateAction<boolean>>,
  transactionDocuments:TTransactionDocuments[], setTransactionDocuments: React.Dispatch<React.SetStateAction<TTransactionDocuments[]>>,
  transactionImages:TTransactionImage[],setTransactionImages:React.Dispatch<React.SetStateAction<TTransactionImage[]>>,
  userAuthFiles:TUSerAuthFile[],setUserAuthFiles:React.Dispatch<React.SetStateAction<TUSerAuthFile[]>>,
  transactionInvoices:TTransactionInvoice[],setTransactionInvoices:React.Dispatch<React.SetStateAction<TTransactionInvoice[]>>,
  resetOrder: () => any
}

export const TransactionContext = createContext<TTransactionContext>({} as TTransactionContext)

const TransactionProvider = (props: any) => {

  const [inboundDetails, setInboundDetails] = useState<TInboundFields>({} as TInboundFields)
  const [meltingLot, setMeltingLot] = useState<TMeltingLot[]>([] as TMeltingLot[])
  const [lineDetails, setLineDetails] = useState<TLineDetails[]>([] as TLineDetails[])
  const [lineItems, setLineItems] = useState<TLineItem[]>([] as TLineItem[])
  const [transferPvcToPlant, setTransferPvcToPlant] = useState<TTransferPvcToPlant>({} as TTransferPvcToPlant)
  const [inboundOrder, setInboundOrder] = useState<TOrder>({} as TOrder)
  const [physicalOrder, setPhysicalOrder] = useState<TOrder>({} as TOrder)
  const [deliveryData, setDeliveryData] = useState<TDelivery[]>([] as TDelivery[])
  const [billingData, setBillingData] = useState<TBilling>({} as TBilling)
  const [payments, setPayments] = useState<TPayment[]>([])
  const [capturedSteps, setCapturedSteps] = useState<TStepsKeys[]>([])
  const [transactionInfo, setTransactionInfo] = useState<TTransactionBasic>({} as TTransactionBasic)
  const [transactions, setTransactions] = useState<TTransactionSummary[]>([])
  const [transitionHistory, setTransitionHistory] = useState<TTransitionHistory[]>([])
  const [products, setProducts] = useState<TSku[]>([])
  const [cart, setCart] = useState<TCartItem[]>([])
  const [charges, setCharges] = useState<TCharge[]>([])
  const [pvcCenterDetails,setPvcCenterDetails] = useState<IPvcCenterSummary>({} as IPvcCenterSummary)
  const [jobworkInventory,setJobworkInventory] = useState<TInventory>({} as TInventory)
  const [pvcCenters, setPvcCenters] = useState<IPvcCenterSummary[]>([])
  const [isInventoryExist, setIsInventory] = useState<boolean>(false)
  const [transactionDocuments, setTransactionDocuments] = useState<TTransactionDocuments[]>([])
  const [transactionImages, setTransactionImages] = useState<TTransactionImage[]>([])
  const [userAuthFiles, setUserAuthFiles] = useState<TUSerAuthFile[]>([])
  const [isEmployeeVerified, setIsEmployeeVerified] = useState(false);
  const [transactionInvoices, setTransactionInvoices] = useState<TTransactionInvoice[]>([])

    const resetOrder = () => {
    setInboundDetails({} as IOrderData)
    setMeltingLot([] as TMeltingLot[])
    setTransferPvcToPlant({} as TTransferPvcToPlant)
    setPhysicalOrder({} as TOrder)
    setDeliveryData([] as TDelivery[])
    setBillingData({} as TBilling)
    setPayments([])
    setTransactionInfo({} as TTransactionBasic)
    setTransactions([])
    setCapturedSteps([])
    setTransactionInfo({} as TTransactionBasic)
    setTransactions([])
    setProducts([])
    setCart([])
    setInboundOrder({} as TOrder)
    setCharges([])
    setTransitionHistory([])
    setPvcCenterDetails({} as IPvcCenterSummary)
    setJobworkInventory({} as TInventory)
    setPvcCenters([])
    setLineItems([])
    setTransactionDocuments([])
    setTransactionImages([])
    setUserAuthFiles([])
    setIsEmployeeVerified(false);
    setTransactionInvoices([])
  }

  return (
    <TransactionContext.Provider
      value={{
        inboundDetails, setInboundDetails, 
        meltingLot, setMeltingLot,
        lineDetails, setLineDetails,
        transferPvcToPlant, setTransferPvcToPlant,
        physicalOrder, setPhysicalOrder,
        deliveryData, setDeliveryData,
        billingData, setBillingData,
        capturedSteps, setCapturedSteps,
        transactionInfo, setTransactionInfo,
        transactions, setTransactions,
        products, setProducts,
        cart, setCart,
        lineItems, setLineItems,
        inboundOrder, setInboundOrder,
        charges, setCharges,
        payments, setPayments,
        transitionHistory, setTransitionHistory,
        pvcCenterDetails,setPvcCenterDetails,
        jobworkInventory, setJobworkInventory,
        pvcCenters, setPvcCenters,
        resetOrder,
        isInventoryExist, setIsInventory,
        transactionDocuments, setTransactionDocuments,
        transactionImages, setTransactionImages,
        userAuthFiles, setUserAuthFiles,
        isEmployeeVerified,setIsEmployeeVerified,
        transactionInvoices, setTransactionInvoices
      }}>
      {props.children}
    </TransactionContext.Provider>
  )
}

export default TransactionProvider
